export default __webpack_public_path__ + "static/media/IMG_5088.71472b23.png";